import * as React from 'react'
import {Button, Checkbox, Col, Divider, Form, Icon, Input, InputNumber, Row, Select} from 'antd';
import {WithTranslation} from 'react-i18next';
import {EmployeeItem} from 'src/stores/employees-store';
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import ManagerEditor from '../../../../components/manager-editor';
import EditableTooltip from '../../../../components/editable-tooltip/tooltip';
import RestrictionPlansEditor from '../../../../components/restriction-plans-editor';
import LabelIcon from '../../../../components/editable-tooltip/label-icon';
import {userHasRole, UserProfileProps} from "../../../../components/user-profile";

let FormItem = Form.Item;

interface ClassFormBodyProps extends WithTranslation, UserProfileProps {
    companyId: string,
    item: EmployeeItem | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    getFieldValue(fieldName: string): any;
    setFieldsValue: any;
    openRestrictionPlanAddModal?: () => void,
    openHierarchyModal?: () => void,
    disabled?: boolean,
}

interface EmployeeViewState {
    value?: number,
    selectedTeamReport: boolean,
    selectedEmployeeReminder: boolean,
}

export class EmployeeFormBody extends React.Component<ClassFormBodyProps, EmployeeViewState> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        var item = props.item || {} as EmployeeItem
        this.state = {
            value: props.item ? props.item.id : undefined,
            selectedEmployeeReminder: item!.timesheetReminder > 0,
            selectedTeamReport: item!.teamReport > 0
        }
    }

    componentDidUpdate(prev: ClassFormBodyProps) {
        if (prev.item != this.props.item) {
        }
    }
  
    static getDerivedStateFromProps(props: ClassFormBodyProps, state: EmployeeViewState) {
        let item = props.item as any;
        if (item.id != state.value) {
            return {
                ...state,
                value: item.id,
            };
        }
        return state;
    }

    @autobind
    private handleFocus(event: any) {
        event.target.select();
    }

    @autobind
    private teamReportOnchange(e: any) {
        this.setState({ selectedTeamReport: !this.state.selectedTeamReport },
            () => {this.state.selectedTeamReport ? this.props.setFieldsValue({ 'teamReport': 1, }):this.props.setFieldsValue({ 'teamReport': false, })})
    
    }

    @autobind
    private employeeReminderOnchange(e: any) {
        this.setState({ selectedEmployeeReminder: !this.state.selectedEmployeeReminder },
            () => { this.state.selectedEmployeeReminder ? this.props.setFieldsValue({ 'timesheetReminder': 1, }) : this.props.setFieldsValue({ 'timesheetReminder': false, }) })
    }

    render() {
        const { t } = this.props;
        var item = this.props.item || {} as EmployeeItem;
        const { Option } = Select;

        return <Form id="modaForm" onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>

            <Row gutter={24} align='middle' justify='center' >
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Identification")}</h5>
                </Col>
            </Row>
            <Row gutter={24} align='middle' justify='center' >
            <Col span={24}>
            <FormItem label={t("Title")}>
                {this.props.getFieldDecorator(nameof<EmployeeItem>('title'), {
                  initialValue: item.title
                })(
                  <Input disabled placeholder={t('Title')} type="text" />
                )}
              </FormItem>
              </Col>
              <Col span={12} >
                <Row gutter={24}>
                  <Col span={24} >
                      <FormItem label={t("First Name")}>
                        {this.props.getFieldDecorator(nameof<EmployeeItem>('name'), {
                          initialValue: item.name,
                        })(
                          <Input disabled={this.props.disabled} placeholder={t('First Name')} type="text" />
                        )}
                      </FormItem>
                  </Col>
                </Row>
                <Row gutter={24}>
                          <Col span={24} >
                              <EditableTooltip name="new-employee-function" noIcon>
                                  <FormItem label={t("Function")}>
                                      {this.props.getFieldDecorator(nameof<EmployeeItem>('function'), {
                                          initialValue: item.function,
                                      })(
                                          <Input disabled={this.props.disabled} placeholder={t('Function')} type="text" />
                                      )}
                                  </FormItem>
                              </EditableTooltip>
                          </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={24} >
                      <FormItem label={t("Code")}>
                        {this.props.getFieldDecorator(nameof<EmployeeItem>('code'), {
                          initialValue: item.code,
                        })(
                          <Input disabled={this.props.disabled} placeholder={t('Code')} type="text" />
                        )}
                      </FormItem>
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row gutter={24}>
                  <Col span={24} >
                      <FormItem label={t("Family Name")}>
                        {this.props.getFieldDecorator(nameof<EmployeeItem>('lastName'), {
                          initialValue: item.lastName,
                        })(
                          <Input disabled={this.props.disabled} placeholder={t('Family Name')} type="text" />
                        )}
                      </FormItem>
                  </Col>
                </Row>
                <EditableTooltip name="new-employee-manager" noIcon offset={8}>
                      <FormItem label={(
                          <LabelIcon>
                              { t("Line manager")}
                          </LabelIcon>
                      )}>
                          {this.props.getFieldDecorator(nameof<EmployeeItem>('managerId'), {
                              initialValue: item.managerId,
                              rules: [],
                          })(
                              <ManagerEditor
                                  placeholder={t("Name")}
                                  companyId={this.props.companyId}
                                  employeeId={item.id}
                                  nullable
                                  disabled={!userHasRole(this.props.userProfile, ["Manager", "Administrator", "ClientAdmin", "FIConsultant"]) || this.props.disabled}
                              />
                          )}
                      </FormItem></EditableTooltip>
                      <Row gutter={24} >
                          <Col span={24} >
                              <FormItem label={t("Language") }>
                                      {this.props.getFieldDecorator(nameof<EmployeeItem>('language'), {
                                          rules: [], initialValue: item.language,
                                      })(
                                          <Select style={{ width: "100" }} >
                                              <Option value={"en"} key={"en"}> {t("English")} </Option>
                                              <Option value={"fr"} key={"fr"}> {t("French")} </Option>
                                              <Option value={"es"} key={"sp"}> {t("Spanish")} </Option>
                                              <Option value={"pt"} key={"pt"}> {t("Portuguese")} </Option>
                                              <Option value={"it"} key={"it"}> {t("Italian")} </Option>
                                          </Select>
                                      )}
                                  </FormItem>
                          </Col>
                      </Row>
                  </Col>                
            </Row>
            <Divider />
            <Row gutter={24} >
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Work regime")}</h5>
                </Col>
            </Row>
            <Row gutter={24} >


                <Col span={24}>

                    <FormItem label={<EditableTooltip name="employee-form-working-regime">{t("Apply the following restriction plan")}</EditableTooltip>} >
                        <Row  >
                            <Col span={14} style={{ maxWidth: 425 }} >

                                {this.props.getFieldDecorator(nameof<EmployeeItem>('restrictionPlanId'), {
                                    initialValue: item.restrictionPlanId,
                                    rules: [],
                                })(
                                    <RestrictionPlansEditor
                                        value={item.restrictionPlanId}
                                        placeholder={t("No plan selected")}
                                        companyId={this.props.companyId}
                                        disabled={!userHasRole(this.props.userProfile, ["Manager", "Administrator", "ClientAdmin", "FIConsultant"]) || this.props.disabled}
                                        emptySign={t('There are no work regimes for this company yet and therefore the range to allocate hours is set between 0h and 24h')}
                                    />
                                )}

                            </Col>
                            <Col span={2}>
                                <Button disabled={this.props.disabled} style={{ marginTop: '4px', marginLeft: -12 }} icon="plus" onClick={this.props.openRestrictionPlanAddModal} />
                            </Col >
                        </Row>

                    </FormItem>
                </Col>
            </Row>
            <Divider />
            <Row gutter={24}>
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Notification options")}</h5>
                </Col>
            </Row>

            <Row gutter={24}>

                <Col span={24}>
                    <Row gutter={24} type={'flex'} align='middle'>
                        <Col span={14}>
                            <EditableTooltip name="new-employee-send-weekly-reminder" noIcon>
                                <Checkbox disabled={this.props.disabled} checked={this.state.selectedEmployeeReminder} defaultChecked={this.state.selectedEmployeeReminder} onChange={this.employeeReminderOnchange}><span>{t("Send reminders for timesheet entry")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                            </EditableTooltip>
                        </Col>
                        <Col span={10}>
                            <FormItem>
                                {this.props.getFieldDecorator(nameof<EmployeeItem>('timesheetReminder'), {
                                    rules: [], initialValue: item.timesheetReminder ? (this.state.selectedEmployeeReminder ? item.timesheetReminder : false) : (this.state.selectedEmployeeReminder ? 1 : false)
                                })(
                                    <Select disabled={!this.state.selectedEmployeeReminder || this.props.disabled} style={{ width: "100" }} >
                                        <Option value={1} key={1}> {t("Weekly")} </Option>
                                        <Option value={2} key={2}> {t("Fortnightly")} </Option>
                                        <Option value={3} key={3}> {t("Monthly")} </Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={24} type={'flex'} align='middle'>
                        <Col span={14}>
                            <EditableTooltip name="new-employee-send-team-report" noIcon>
                                <Checkbox disabled={this.props.disabled} checked={this.state.selectedTeamReport} defaultChecked={this.state.selectedTeamReport} onChange={this.teamReportOnchange} ><span>{t("Send team report")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                            </EditableTooltip>
                        </Col>
                        <Col span={10}>
                            <FormItem>
                                {this.props.getFieldDecorator(nameof<EmployeeItem>('teamReport'), {
                                    rules: [], initialValue: item.teamReport ? (this.state.selectedTeamReport ? item.teamReport : false) : (this.state.selectedTeamReport ? 1 : false)
                                })(
                                    <Select disabled={!this.state.selectedTeamReport || this.props.disabled} style={{ width: "100" }} >
                                        <Option value={2} key={2}> {t("Quickly")} </Option>
                                        <Option value={1} key={1}> {t("Monthly")} </Option>
                                        <Option value={3} key={3}> {t("Quarterly")} </Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                            <EditableTooltip name="new-employee-send-timesheet-status-notification-employee" noIcon>
                                <FormItem>
                                    {this.props.getFieldDecorator(nameof<EmployeeItem>('timesheetStatusNotificationEmployee'), {
                                        rules: [], initialValue: item.timesheetStatusNotificationEmployee, valuePropName: 'checked'
                                    })(
                                        <Checkbox disabled={this.props.disabled}><span>{t("Send an email when approving / rejecting timesheet")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                            </EditableTooltip>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                            <EditableTooltip name="new-employee-send-timesheet-status-notification-manager" noIcon>
                                <FormItem>
                                    {this.props.getFieldDecorator(nameof<EmployeeItem>('timesheetStatusNotificationManager'), {
                                        rules: [], initialValue: item.timesheetStatusNotificationManager, valuePropName: 'checked'
                                    })(
                                        <Checkbox disabled={this.props.disabled}><span>{t("Send e-mail when timesheet has been published")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                            </EditableTooltip>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                         <Col span={24}>
                            <EditableTooltip name="new-employee-send-deleted-project-notification" noIcon>
                                <FormItem>
                                    {this.props.getFieldDecorator(nameof<EmployeeItem>('deletedProjectNotification'), {
                                        rules: [], initialValue: item.deletedProjectNotification, valuePropName: 'checked'
                                    })(
                                        <Checkbox><span>{t("Send e-mail when a project has been deleted")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                    )}
                                </FormItem>
                            </EditableTooltip>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Divider />
            <Row gutter={24}>
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{t("Timesheet option")}</h5>
                </Col>
            </Row>
            <Row gutter={24}>

                <Col span={24}>
                    <EditableTooltip name="new-employee-clone-previous-timesheet" noIcon>
                        <FormItem>
                            {this.props.getFieldDecorator(nameof<EmployeeItem>('cloneTimesheet'), {
                                rules: [], initialValue: item.cloneTimesheet, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.disabled}><span>{t("Clone previous timesheet tasks when generating new timesheet")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                            )}
                        </FormItem>
                    </EditableTooltip>
                </Col>
            </Row>
            <Divider />

            {
                (item.allowedCir || item.allowedCii) &&
                <div>
                    <Row gutter={24}>
                        <Col span={8}>
                            <h5 style={{ fontWeight: 'bold', marginTop: '7px' }}>{(item.allowedCir && item.allowedCii) ? t("Eligibility for CIR / CII") : item.allowedCir ? t("Eligibility for CIR") : t("Eligibility for CII") }</h5>
                        </Col>
                     </Row>
                    <Row gutter={24}>

                        {
                            item.allowedCir &&
                            <Col span={12}>
                                <EditableTooltip name="new-employee-CIR-eligible" noIcon>
                                    <FormItem>
                                        {this.props.getFieldDecorator(nameof<EmployeeItem>('cirEligible'), {
                                            rules: [], initialValue: item.cirEligible, valuePropName: 'checked'
                                        })(
                                            <Checkbox disabled={this.props.disabled || !item.allowedCir}><span>{t("Profile is eligible to CIR")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                        )}
                                    </FormItem>
                                </EditableTooltip>
                            </Col>
                        }
                        {
                            item.allowedCii &&
                            <Col span={12}>
                                <EditableTooltip name="new-employee-CII-eligible" noIcon>
                                    <FormItem>
                                        {this.props.getFieldDecorator(nameof<EmployeeItem>('ciiEligible'), {
                                            rules: [], initialValue: item.ciiEligible, valuePropName: 'checked'
                                        })(
                                            <Checkbox disabled={this.props.disabled || !item.allowedCii}><span>{t("Profile is eligible to CII")}</span><Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginRight: 3, marginLeft: 3 }} /></Checkbox>
                                        )}
                                    </FormItem>
                                </EditableTooltip>
                            </Col>
                        }
                    </Row>
                    <Divider />
                </div>
            }
            <Row gutter={24}>
                <Col span={8}>
                    <h5 style={{ fontWeight: 'bold' }}>{t('Estimated hourly cost (in ') + item.currency + ')'}</h5>
                </Col>
            </Row>

            <Row gutter={24}>

                <Col span={24}>
                    <Row>
                        {t('Estimated hourly cost (in ') + item.currency + ')'}
                    </Row>
                    <Row>
                        <EditableTooltip name="new-employee-estimated-hourly-cost" noIcon>
                            <FormItem>

                                {this.props.getFieldDecorator(nameof<EmployeeItem>('estimatedHourlyCost'), {
                                    rules: [], initialValue: item.estimatedHourlyCost, valuePropName: 'value'
                                })(
                                    <InputNumber
                                        disabled={this.props.disabled}
                                        style={{ width: '234.17px' }}
                                        min={0} step={0.25}
                                        defaultValue={item.estimatedHourlyCost}
                                        formatter={value => value ? `${value}` + item.currency : "0.00" + item.currency}
                                        parser={value => value ? value.replace(item.currency, '') : ''}
                                        onFocus={this.handleFocus}
                                    >
                                        {t("estimated hourly cost")}
                                    </InputNumber>

                                )}
                            </FormItem>
                        </EditableTooltip>
                    </Row>
                </Col>
            </Row>
            <Divider style={{ marginTop: "30px", marginBottom:"30px" }} /> 
           
            <Row gutter={24}>
                <Col span={24}>
                    <Row>
                        <Button icon="apartment" onClick={this.props.openHierarchyModal} >{t("Employee hierarchy")}</Button>
                    </Row>
                </Col>
            </Row>

        </Form>
    }
}
